import { recordError } from "src/utilities/errorReporting"
import { tryFetch, tryParseJson } from "src/utilities/http"
import { createPersistentStore } from "src/utilities/localStorage/create"

export type GeoData = {
  "About Us": string
  ip: string
  success: boolean
  type: string
  continent: string
  continent_code: string
  country: string
  country_code: string
  region: string
  region_code: string
  city: string
  latitude: number
  longitude: number
  is_eu: boolean
  postal: string
  calling_code: string
  capital: string
  borders: string
  flag: {
    img: string
    emoji: string
    emoji_unicode: string
  }
  connection: {
    asn: number
    org: string
    isp: string
    domain: string
  }
  timezone: {
    id: string
    abbr: string
    is_dst: boolean
    offset: number
    utc: string
    current_time: string
  }
}

type State = {
  lastUpdated: number
  data: GeoData | null
}

const defaultState: State = {
  lastUpdated: 0,
  data: null,
}

const store = createPersistentStore(() => defaultState, { name: "geo", version: 2 })

let promise: Promise<void> | null = null

async function fetchAndStoreGeoData() {
  const response = await tryFetch("https://ipwho.is/")
  const data = await tryParseJson<GeoData>(response)
  store.setState({ lastUpdated: Date.now(), data })
}

async function updateGeoDataOnce() {
  const lastUpdated = store.getState().lastUpdated
  const now = Date.now()

  // Skip if the last update was less than 1 day ago
  if (now - lastUpdated < 1000 * 60 * 60 * 24) {
    promise = null
    return
  }

  if (!promise) {
    promise = fetchAndStoreGeoData()
  }

  await promise
}

export async function getGeoData() {
  try {
    await updateGeoDataOnce()
  } catch (error) {
    recordError("Error fetching geo data", error)
  }
  return store.getState().data
}
